var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWebastoTurnedOff = function SvgWebastoTurnedOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3585",
    width: 44,
    height: 44,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1008.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3849",
    fill: "currentColor",
    fillOpacity: 0.7,
    transform: "matrix(.5 0 0 .5 -418 990.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3937",
    d: "M850.21 99.943h56.958V107H850.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3940",
    d: "M864.79 96.307s4.615-5.827 4.615-10.8V62.463h-3.461L873.287 53l7.132 9.356h-3.251v25.289c0 7.488-12.378 8.661-12.378 8.661z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3942",
    d: "M850 96.307s4.615-5.827 4.615-10.8V62.463h-3.461L858.497 53l7.132 9.356h-3.251v25.289c0 7.488-12.378 8.661-12.378 8.661z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3944",
    d: "M894.37 96.307s4.615-5.827 4.615-10.8V62.463h-3.461L902.867 53l7.132 9.356h-3.251v25.289c0 7.488-12.378 8.661-12.378 8.661z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3946",
    d: "M879.58 96.307s4.615-5.827 4.615-10.8V62.463h-3.461L888.077 53l7.132 9.356h-3.251v25.289c0 7.488-12.378 8.661-12.378 8.661z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWebastoTurnedOff);
export default ForwardRef;